import { createAction } from 'Helpers';
import ReportTypes from './types';

const reportsActions = {
	couponTransactionsRequest: createAction(
		ReportTypes.COUPON_TRANSACTIONS.REQUEST
	),
	couponTransactionsSuccess: createAction(
		ReportTypes.COUPON_TRANSACTIONS.SUCCESS
	),
	couponTransactionsFailure: createAction(
		ReportTypes.COUPON_TRANSACTIONS.FAILURE
	),
	clearCouponTransactions: createAction(ReportTypes.COUPON_TRANSACTIONS.CLEAR),

	couponTransactionsOverviewRequest: createAction(
		ReportTypes.COUPONS_TRANSACTIONS_OVERVIEW.REQUEST
	),
	couponTransactionsOverviewSuccess: createAction(
		ReportTypes.COUPONS_TRANSACTIONS_OVERVIEW.SUCCESS
	),
	couponTransactionsOverviewFailure: createAction(
		ReportTypes.COUPONS_TRANSACTIONS_OVERVIEW.FAILURE
	),
	clearcouponTransactionsOverview: createAction(
		ReportTypes.COUPONS_TRANSACTIONS_OVERVIEW.CLEAR
	),
	paymentRequestTransactionsRequest: createAction(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS.REQUEST
	),
	paymentRequestTransactionsSuccess: createAction(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS.SUCCESS
	),
	paymentRequestTransactionsFailure: createAction(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS.FAILURE
	),
	clearpaymentRequestTransactions: createAction(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS.CLEAR
	),
	paymentRequestTransactionsOverviewRequest: createAction(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW.REQUEST
	),
	paymentRequestTransactionsOverviewSuccess: createAction(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW.SUCCESS
	),
	paymentRequestTransactionsOverviewFailure: createAction(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW.FAILURE
	),
	clearpaymentRequestTransactionsOverview: createAction(
		ReportTypes.PAYMENT_REQUEST_TRANSACTIONS_OVERVIEW.CLEAR
	),
	ReportTransactionsPackageRequest: createAction(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE.REQUEST
	),
	ReportTransactionsPackageSuccess: createAction(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE.SUCCESS
	),
	ReportTransactionsPackageFailure: createAction(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE.FAILURE
	),
	ReportTransactionsPackageClear: createAction(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE.CLEAR
	),
	ReportChartPackageRequest: createAction(
		ReportTypes.REPORT_CHART_PACKAGE.REQUEST
	),
	ReportChartPackageSuccess: createAction(
		ReportTypes.REPORT_CHART_PACKAGE.SUCCESS
	),
	ReportChartPackageFailure: createAction(
		ReportTypes.REPORT_CHART_PACKAGE.FAILURE
	),
	ReportChartPackageClear: createAction(ReportTypes.REPORT_CHART_PACKAGE.CLEAR),
	ReportChartPackageOffcbRequest: createAction(
		ReportTypes.REPORT_CHART_PACKAGE_OFFCB.REQUEST
	),
	ReportChartPackageOffcbSuccess: createAction(
		ReportTypes.REPORT_CHART_PACKAGE_OFFCB.SUCCESS
	),
	ReportChartPackageOffcbFailure: createAction(
		ReportTypes.REPORT_CHART_PACKAGE_OFFCB.FAILURE
	),
	ReportChartPackageOffcbClear: createAction(
		ReportTypes.REPORT_CHART_PACKAGE_OFFCB.CLEAR
	),
	ReportTransactionsPackageOffcbRequest: createAction(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE_OFFCB.REQUEST
	),
	ReportTransactionsPackageOffcbSuccess: createAction(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE_OFFCB.SUCCESS
	),
	ReportTransactionsPackageOffcbFailure: createAction(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE_OFFCB.FAILURE
	),
	ReportTransactionsPackageOffcbClear: createAction(
		ReportTypes.REPORT_TRANSACTIONS_PACKAGE_OFFCB.CLEAR
	),
};

export default reportsActions;
